<div class="mt-3 flex flex-col gap-3">
  <div
    #paper
    class="signature-paper relative h-56 w-full select-none overflow-hidden rounded-xl border border-gray-200 bg-white shadow-[inset_0_1px_4px_rgba(0,0,0,0.05)] sm:h-64 dark:border-gray-600"
    data-testid="garage-signature-pad"
  >
    <soft-signature-pad
      [options]="padOptions"
      (pointerdown)="onStrokeBegin()"
      (pointerup)="onStrokeEnd()"
    />

    <div
      class="pointer-events-none absolute inset-x-8 bottom-12 flex items-end gap-3 sm:bottom-14"
    >
      <soft-icon
        name="fa-regular fa-xmark"
        class="-mb-1 text-lg text-gray-300 dark:text-gray-500"
      />
      <div class="flex-1 border-b-2 border-dashed border-gray-300 dark:border-gray-500"></div>
    </div>
    <div
      class="pointer-events-none absolute inset-x-8 bottom-5 flex items-center justify-between text-[11px] uppercase tracking-widest text-gray-300 sm:bottom-6 dark:text-gray-500"
    >
      <span>Unterschrift</span>
      <span>{{ today | date: 'dd.MM.yyyy' }}</span>
    </div>

    @if (isEmpty()) {
      <div
        class="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-2.5 pb-10"
        animate.leave="placeholder-leave"
      >
        <span
          class="flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 text-gray-400"
        >
          <soft-icon name="fa-regular fa-signature" />
        </span>
        <span class="text-sm text-gray-400">
          Tippen Sie hier, um zu unterschreiben
        </span>
      </div>
    }
  </div>

  <div class="flex flex-wrap items-center justify-between gap-2">
    @if (isEmpty()) {
      <span
        class="inline-flex items-center gap-1.5 text-sm font-medium"
        style="color: var(--ds-text-status-warning)"
      >
        <soft-icon name="fa-regular fa-circle-exclamation" />
        Unterschrift ausstehend
      </span>
    } @else {
      <span
        class="inline-flex items-center gap-1.5 text-sm font-medium"
        style="color: var(--ds-text-status-success)"
      >
        <soft-icon name="fa-regular fa-circle-check" />
        Unterschrift erfasst
      </span>
    }

    <div class="flex items-center gap-1">
      <soft-ds-button
        variant="ghost"
        size="sm"
        [disabled]="isEmpty()"
        (click)="undo()"
        data-testid="garage-signature-undo"
      >
        Rückgängig
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-rotate-left" />
        </ng-template>
      </soft-ds-button>
      <soft-ds-button
        variant="ghost"
        size="sm"
        [disabled]="isEmpty()"
        (click)="clear()"
        data-testid="garage-signature-clear"
      >
        Löschen
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-eraser" />
        </ng-template>
      </soft-ds-button>
    </div>
  </div>

  <div
    class="mt-1 flex flex-col-reverse gap-2 border-t border-gray-100 pt-3 sm:flex-row sm:justify-end dark:border-gray-700"
  >
    <soft-ds-button
      variant="outline"
      size="lg"
      (click)="cancel()"
      data-testid="garage-signature-cancel"
    >
      Abbrechen
    </soft-ds-button>
    <soft-ds-button
      variant="primary"
      size="lg"
      [disabled]="isEmpty()"
      (click)="save()"
      data-testid="garage-signature-save"
    >
      Speichern
      <ng-template softSlot="leading">
        <soft-ds-icon name="fa-regular fa-check" />
      </ng-template>
    </soft-ds-button>
  </div>
</div>
